import {
  parseToAPI,
  parseToAppState,
} from 'containers/ToolBuilder/adapters/Brainstormer'

export const getToolAdapter = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const toolType = searchParams.get('tool_type')
  let adapter = null
  switch (toolType) {
    case 'Brainstormer':
      adapter = {
        parseToAPI,
        parseToAppState,
      }
      break
  }
  if (!adapter) {
    throw new Error(`No adapter found for tool type: ${toolType}`)
  }
  return adapter
}
